/* global window */
import React, { Component } from 'react'
import cookie from 'react-cookies'
import $ from 'jquery'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom'

import 'react-dates/initialize'
import 'antd/dist/antd.less'
import { connect } from 'react-redux'
import get from 'lodash.get'

import ProtectedRoute from './components/ProtectedRoute'
import store from './store'
import Navbar from './components/Navbar'
import { approutes } from './routes'
import PendingModal from './screens/Pendings/components/PendingModal'
import PendingLoading from './screens/Pendings/components/PendingLoading'
import ScrollToTop from './components/ScrollToTop'
import ForgotPassword from './screens/ForgotPassword'
import { bootstrapLogged } from './actions/application'
import Loading from './components/Loading'
import Feedback from './components/Feedback'
import styles from './app.scss'
import './assets/fonts/glober/stylesheet.css'
import './assets/external_css/antd.min.css'
import './assets/external_css/customBtn.css'
import './assets/external_css/daterangepicker.css'
import './assets/external_css/datepicker.css'
import './assets/external_css/rctimepicker.css'
import './assets/external_css/react-autocomplete-input.css'
import './assets/external_css/reactbootstrap.min.css'
import './assets/external_css/reacttoggle.css'
import './assets/external_css/react-image-crop.css'
import './assets/external_css/react-image-gallery.css'
import './assets/external_css/react-map-gl.css'
import './assets/external_css/react-dates.css'
import './commons.scss'
import DailyAlertModal from './components/DailyAlertModal'
import BlipChatWrapper from './components/BlipWrapper'
import { cacheImages } from './utils/fileUtils'
import LazyImport from './components/LazyImport'
import { NotificationModal } from './components/NotificationModal'
import AppError from './screens/AppError'

const NewLoadsRoute = LazyImport(() => import('./screens/NewLoads'))

class App extends Component {
  state = {
    isLaunched: false,
  }
  componentWillMount() {}
  componentDidMount() {
    $('#initialLoader').remove()
    cacheImages([
      'https://storage.googleapis.com/azship-storage/shipper/facade/38161897-84c9-4fe9-a0a9-3489bf0d2a7c.png',
    ])
  }
  render() {
    let logged = false
    if (typeof window !== 'undefined') {
      const localStorage = window.localStorage
      let user = localStorage.getItem('user')
      if (user) {
        user = JSON.parse(user)
      }
      const sessionUser = cookie.load('user')
      const authUser = store.getState().user
      if ((sessionUser && sessionUser[0]) || user || authUser) {
        logged = true
      }
    }
    if (logged) {
      $('#onesignal-bell-container').show()
    } else {
      $('#onesignal-bell-container').hide()
    }
    if (logged && !this.state.isLaunched) {
      this.setState({
        isLaunched: true,
      })
      store.dispatch(bootstrapLogged())
    }

    const routes = this.props.enableSearchFreightByCache
      ? approutes.map((r) => {
          if (r.path === '/loads' || r.path === '/') {
            return { ...r, component: NewLoadsRoute }
          }
          return r
        })
      : approutes

    return (
      <div className={styles.mainContainer}>
        <Navbar />
        <ScrollToTop>
          <div className={styles.main}>
            <PendingLoading />
            <Loading store={store} />
            {typeof window !== 'undefined' ? <Feedback store={store} /> : null}
            <Switch>
              <Route path="/error" exact component={AppError} />
              <Route
                path="/forgotpassword"
                exact
                render={() => {
                  if (logged) {
                    return <Redirect to="/" />
                  }
                  return <ForgotPassword store={store} />
                }}
              />
              {routes.map((route) => (
                <ProtectedRoute key={route.path} isLogged={logged} {...route} />
              ))}
            </Switch>
          </div>
          <BlipChatWrapper />
          <DailyAlertModal />
          <PendingModal />
          <NotificationModal />
        </ScrollToTop>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  enableSearchFreightByCache:
    get(state, 'settings.configs.ENABLE_SEARCH_FREIGHT_BY_CACHE.value', 'true') === 'true',
})

export default withRouter(connect(mapStateToProps, null)(App))
